import React, { useState } from 'react'

import Customers from './Customers'
import Drivers from './Drivers'
import Admins from './Admins/Admins'
import Carriers from './Carriers'
import RentalCompanies from './RentalCompanies'
import Controllers from './Controllers'
import TransportManagers from './TransportManagers'
import Emails from './Emails'

const tabItems = [
  { label: 'Användare', value: 'customers' },
  { label: 'Chaufförer', value: 'drivers' },
  { label: 'Admins', value: 'admins' },
  { label: 'Transportörer', value: 'carriers' },
  { label: 'Uthyrningsdepåer', value: 'rentalCompanies' },
  { label: 'Controllers', value: 'controllers' },
  { label: 'Transportansvarig', value: 'transportManagers' },
  { label: 'E-post', value: 'emails' },
]

const Support = ({ history }) => {
  const [activeTab, setActiveTab] = useState('customers')

  const handleCustomerStateChange = (controller) => {
    setActiveTab('controllers')
    history.push(`/data-analytics/support?qlocxid=${controller}`)
  }

  return (
    <div>
      <div className="flex" style={{ justifyContent: 'flex-start' }}>
        {tabItems.map((item) => {
          const isActive = item.value === activeTab

          return (
            <div key={item.label} onClick={() => setActiveTab(item.value)} className="DataAnalyticsMenubar" style={{ color: isActive ? 'white' : 'black', background: isActive ? '#006e78' : 'white' }}>
              {item.label}
            </div>
          )
        })}
      </div>
      {activeTab === 'customers' && <Customers onControllerClick={handleCustomerStateChange} />}
      {activeTab === 'drivers' && <Drivers />}
      {activeTab === 'admins' && <Admins />}
      {activeTab === 'carriers' && <Carriers />}
      {activeTab === 'rentalCompanies' && <RentalCompanies />}
      {activeTab === 'controllers' && <Controllers />}
      {activeTab === 'transportManagers' && <TransportManagers />}
      {activeTab === 'emails' && <Emails />}
    </div>
  )
}

export default Support
